import styled, { css } from 'styled-components';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';
import { headersTagStyles, tagStyles } from '../../../ui/Typography/styles';

export const PriceSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  padding: 0 0 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding-bottom: 20px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 5px;
  }
`;

export const SectionPrice = styled(Typography)<{
  $withBigMargin: boolean;
  $withMargin: boolean;
}>`
  display: block;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${headersTagStyles.h9}
  }

  ${({ $withMargin, $withBigMargin }) =>
    $withMargin &&
    css`
      margin-bottom: ${!$withBigMargin ? '15px' : '3px'};

      @media (min-width: ${Breakpoints.tablet}px) {
        margin-bottom: ${!$withBigMargin ? '20px' : '5px'};
      }
    `}
`;

export const SectionPricePerUnit = styled(Typography)`
  display: block;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${tagStyles.title_3_desc}
  }
`;

export const SectionArea = styled(Typography)<{
  $isKapitalbankApplicable: boolean;
}>`
  display: block;

  ${({ $isKapitalbankApplicable }) =>
    $isKapitalbankApplicable &&
    css`
      margin-bottom: 15px;

      @media (min-width: ${Breakpoints.tablet}px) {
        margin-bottom: 20px;
      }
    `};

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${headersTagStyles.h3}
  }
`;
